import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { ArticleCard } from "@/components/Cards";
import { RANGER_AVATAR } from "@/lib/constants";

const CATS = ["All", "Weekly", "Guide", "Listicle", "Evergreen", "News"];

export default function Guides() {
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => {
    const params = cat !== "All" ? { category: cat } : {};
    api.get("/articles", { params }).then((r) => setArticles(r.data));
  }, [cat]);

  return (
    <div>
      <Seo title="RiNo Guides & Stories" description="Guides, listicles, and neighborhood news from The RiNo Ranger — things to do, best breweries, First Fridays, murals, and more in Denver's River North." image={RANGER_AVATAR} />
      <PageHeader overline="From The RiNo Ranger" title="Guides, Listicles & News" subtitle="Fresh, local content written by The RiNo Ranger — your AI guide to everything happening in the River North Art District." image={RANGER_AVATAR} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-wrap gap-2 mb-8">
          {CATS.map((c) => (
            <button key={c} data-testid={`guide-filter-${c.toLowerCase()}`} onClick={() => setCat(c)}
              className={`px-4 py-2 text-sm border transition-colors ${cat === c ? "border-[#FF0055] bg-[#FF0055]/10 text-white" : "border-white/15 text-neutral-400 hover:text-white"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="guides-list">
          {articles.map((a, i) => <ArticleCard key={a.id} a={a} index={i} />)}
        </div>
        {articles.length === 0 && <div className="text-neutral-500 py-20 text-center">No stories in this category yet.</div>}
      </div>
    </div>
  );
}
